import { LengthConversionFactors } from "./LengthConversionFactors";
import { LengthUnits } from "./LengthUnits";
import { NumberWithUnit, NumberWithUnitConstructor, UnitSource } from "./NumberWithUnit";
import { Unit } from "./Unit";
import { UnitConversionFactorGroup } from "./UnitConversionFactorGroup";

export class Length extends NumberWithUnit {
    protected override get cls(): NumberWithUnitConstructor {
        return Length;
    }

    public override get unitGroup(): LengthUnits {
        return LengthUnits.singleton;
    }

    public override convert(targetUnit: UnitSource): number {
        const targetUnitAbbreviation = Unit.resolveAbbreviation(targetUnit);
        return this.convertWithPrecision(targetUnitAbbreviation, 2);
    }

    public override getConversionFactors(): UnitConversionFactorGroup {
        return LengthConversionFactors.get();
    }
}
